/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.671
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveHouseSchoolInfo,
	getHouseSchoolInfoCreateInit,
	getHouseSchoolInfoEditInit,
	getHouseSchoolInfoView,
	deleteHouseSchoolInfo
} from '@api/lcf/HouseSchoolInfo';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getHouseSchoolInfoCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getHouseSchoolInfoCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseSchoolInfoEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseSchoolInfoEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveHouseSchoolInfo({}, HouseSchoolInfo) {
			return new Promise((resolve, reject) => {
				saveHouseSchoolInfo(HouseSchoolInfo)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseSchoolInfoView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseSchoolInfoView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseSchoolInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseSchoolInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
